export default function init() {
    document.body.addEventListener('click', (event) => {
        const title = event.target.closest(
            '.product-fieldset-wrapper .product-fieldset.section .product-fieldset-accordion.accordion .product-fieldset-accordion-title'
        );

        if (title) {
            const parentAccordion = title.closest('.accordion');
            if (parentAccordion) {
                const isActive = parentAccordion.classList.toggle('active');

                const elementClicked = parentAccordion.getAttribute('data-element') || '';
                const position = parentAccordion.getAttribute('data-order') || '';
                const linkTextElement = title.querySelector('h4');
                const linkText = linkTextElement ? linkTextElement.textContent.trim() : '';
                const direction = isActive ? 'open' : 'close';

                const defaultData = {
                    event: 'on_page_link_click',
                    elementPlacement: 'product-fieldset-accordion',
                    elementClicked: elementClicked,
                    pageType: window?.pageType,
                    pageUrl: window.location.href,
                    position: position,
                    linkText: linkText,
                    direction: direction,
                };

                window.dataLayer.push(defaultData);
                console.log(defaultData);
            }
        }
    });
}
